import { useEffect, useState } from "react";
import { FiInfo } from "react-icons/fi";
import GenreProgress from "../components/GenreProgress";
import UserRanking from "../components/UserRanking";
import MoviePoster from "../components/MoviePosterBadges";
import MedalsModal from "../components/MedalsModal";
import CarteleraModal from "../components/CarteleraModal";
import AlbumModal from "../components/AlbumModal";

export default function Badges() {
//  Datos hardcodeados a modo de prueba
  const genres = [
    { name: "Drama", achieved: 2 },
    { name: "Terror", achieved: 2 },
    { name: "Fantasía", achieved: 2 },
    { name: "Comedia", achieved: 2 },
    { name: "Acción", achieved: 2 },
    { name: "Románticas", achieved: 2 },
    { name: "Ciencia Ficción", achieved: 2 },
    { name: "Musical", achieved: 2 },
    { name: "Documental", achieved: 2 },
    { name: "Thrillers", achieved: 2 },
    { name: "Animadas", achieved: 2 },
  ];

  const totalAchieved = genres.reduce((sum, g) => sum + g.achieved, 0);
  const totalPossible = genres.length * 5;
  const totalPercent = Math.round((totalAchieved / totalPossible) * 100);

  const users = [
    { name: "Usuario 1", position: 1 },
    { name: "Usuario 2", position: 2 },
    { name: "Usuario 3", position: 3 },
    { name: "Usuario 4", position: 4 },
    { name: "Usuario 5", position: 5 },
    { name: "Usuario 6", position: 6 },
  ];

  const [posters, setPosters] = useState([]);
  const [showMedallasModal, setShowMedallasModal] = useState(false);
  const [showCarteleraModal, setShowCarteleraModal] = useState(false);
  const [showAlbumModal, setShowAlbumModal] = useState(false);
  const [albumPoster, setAlbumPoster] = useState(null);

  useEffect(() => {

    // Función para obtener los postersdesde la API de prueba
    const fetchPosters = async () => {
      const apiKey = "32e2b0a3a1547ca2540e8f09f67feb97";
      const url = `https://api.themoviedb.org/3/movie/popular?api_key=${apiKey}&language=en-US&page=1`;

      try {
        const res = await fetch(url);
        const data = await res.json();
        setPosters(data.results.slice(0, 4));

        if (data.results.length > 0) {
          setAlbumPoster(data.results[0]);
        }
      } catch (err) {
        console.error("Error al obtener posters:", err);
      }
    };

    fetchPosters();
  }, []);

  return (
    <div className="min-h-screen bg-black text-white p-4 pt-20 font-montserrat">


      
      <div className="max-w-3xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">Logros</h1>
          <p className="text-sm text-gray-400">
            En esta sección encontrarás todos logros que has desbloqueado
            mirando películas en la plataforma.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-4">
          {/* Columna izquierda */}
          <div className="flex-1 flex flex-col">
            <div
              className="bg-zinc-900 rounded-2xl p-4 flex-grow"
              style={{
                backgroundImage: "url('/images/background1.png')",
                backgroundPosition: "center center",
                backgroundSize: "cover",
              }}
            >
              <h2 className="text-lg font-bold mb-2 flex items-center">
                Medallas
                <button onClick={() => setShowMedallasModal(true)}>
                  <FiInfo className="ml-2 text-yellow-400 cursor-pointer" />
                </button>
              </h2>

              <p className="text-sm text-gray-400 mb-4">
                Gana medallas y trofeos viendo pelis. Se desbloquearán
                películas sorpresa.
              </p>
              <h3 className="text-md font-semibold mb-4">Logros totales</h3>
              <div className="flex items-center mb-4">
                <img
                  src="/images/medalla.png"
                  alt="Medalla"
                  className="w-7 h-7"
                />
                <div className="h-3 bg-gray-700 rounded-full border-2 border-white overflow-hidden w-full">
                  <div
                    className="h-full"
                    style={{
                      width: `${totalPercent}%`,
                      backgroundImage: "url('/images/background1.png')",
                      backgroundSize: "cover",
                    }}
                  ></div>
                </div>
                <span className="text-xs text-gray-400 ml-2">
                  {totalPercent}%
                </span>
              </div>

              <div className="grid grid-cols-2 gap-4">
                {genres.map((genre, index) => (
                  <GenreProgress
                    key={index}
                    genre={genre.name}
                    achieved={genre.achieved}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Columna derecha */}
          <div className="w-full md:w-60 flex flex-col gap-4">
            <div
              className="bg-zinc-900 rounded-2xl p-4 flex-grow  "
              style={{ backgroundImage: "url('/images/background1.png')" }}
            >
              <h2 className="text-lg font-bold mb-4 flex items-center">
                Ranking
                <button onClick={() => setShowMedallasModal(true)}>
                  <FiInfo className="ml-2 text-yellow-400 cursor-pointer" />
                </button>
              </h2>
              <div className="space-y-3">
                {users.map((user) => (
                  <UserRanking
                    key={user.position}
                    name={user.name}
                    position={user.position}
                  />
                ))}
              </div>
            </div>

            <div
              className="bg-zinc-900 rounded-2xl p-4"
              style={{
                backgroundImage: "url('/images/background1.png')",
                backgroundPosition: "top left",
                backgroundSize: "cover",
              }}
            >
              <h2 className="text-lg font-bold mb-2">Posters ocultos</h2>
              <p className="text-sm text-gray-400 mb-4">
                Desbloquea este logro viendo películas y completando el álbum.
              </p>
              <button
                className="bg-yellow-400 text-black font-medium rounded-full py-2 px-6 w-full"
                onClick={() => setShowAlbumModal(true)}
              >
                Ver álbum
              </button>
            </div>

            <div className="bg-yellow-600 rounded-2xl p-4 text-black relative">
              <h2 className="text-lg font-bold mb-2 flex items-center">
                Participa en la próxima cartelera
                <button onClick={() => setShowCarteleraModal(true)}>
                  <FiInfo className="ml-2 text-black cursor-pointer" />
                </button>
              </h2>
              <button className="bg-white/20 border border-white/40 text-black font-medium rounded-full py-2 px-6 w-full">
                Elegir cartelera
              </button>
            </div>
          </div>
        </div>

        {/* Películas desbloqueadas */}
        <div className="mt-8 relative">
          <h2 className="text-lg font-semibold mb-4">
            Películas desbloqueadas
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
            {posters.map((movie) => (
              <MoviePoster
                key={movie.id}
                src={`https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                alt={movie.title}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Modales */}
      <MedalsModal
        isOpen={showMedallasModal}
        onClose={() => setShowMedallasModal(false)}
      />

      <CarteleraModal
        isOpen={showCarteleraModal}
        onClose={() => setShowCarteleraModal(false)}
      />

      <AlbumModal
        isOpen={showAlbumModal}
        onClose={() => setShowAlbumModal(false)}
      />
    </div>
  );
}
